import type { Props } from "../../../../types";
import { classNameParser } from "../../../../helpers";
import "./style.css";

export const InputGroup = (props: Props) => (
  <div
    id={props.id}
    key={props.key}
    className={classNameParser("input--input-group", props.className)}
    style={props.style}
  >
    {props.children}
  </div>
);
